// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../../../node_modules/.pnpm/registry.npmmirror.com+css-loader@6.7.1_webpack@5.74.0/node_modules/css-loader/dist/cjs.js!../../../../../node_modules/.pnpm/registry.npmmirror.com+sass-loader@13.1.0_sass@1.56.0+webpack@5.74.0/node_modules/sass-loader/dist/cjs.js!./base.scss");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = require("!../../../../../node_modules/.pnpm/registry.npmmirror.com+vue-style-loader@4.1.3/node_modules/vue-style-loader/lib/addStylesClient.js").default
var update = add("60685b02", content, false, {});
// Hot Module Replacement
if(module.hot) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/.pnpm/registry.npmmirror.com+css-loader@6.7.1_webpack@5.74.0/node_modules/css-loader/dist/cjs.js!../../../../../node_modules/.pnpm/registry.npmmirror.com+sass-loader@13.1.0_sass@1.56.0+webpack@5.74.0/node_modules/sass-loader/dist/cjs.js!./base.scss", function() {
     var newContent = require("!!../../../../../node_modules/.pnpm/registry.npmmirror.com+css-loader@6.7.1_webpack@5.74.0/node_modules/css-loader/dist/cjs.js!../../../../../node_modules/.pnpm/registry.npmmirror.com+sass-loader@13.1.0_sass@1.56.0+webpack@5.74.0/node_modules/sass-loader/dist/cjs.js!./base.scss");
     if(newContent.__esModule) newContent = newContent.default;
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}